import { Anchor, Box, FormField, FormHelp, Heading, Input, Label } from '@zillow/constellation-10';
import { Controller, useFormContext } from 'react-hook-form';
import { EXTERNAL_URLS, getExternalUrl } from '../../../../constants/urls';
import { MaskedPhoneInput } from '../../../Inputs';
import { isValidUSPhoneNumber } from '../../../../utils/formatters';

export function ContactStep() {
  const {
    formState: { errors },
    getValues,
  } = useFormContext();

  const email = getValues().email;

  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'default', fontFamily: 'heading-alt' }}>
        How can you be reached?
      </Heading>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        <FormField
          label={<Label>Phone number</Label>}
          control={
            <Controller
              name="phone"
              rules={{
                required: 'Phone number is required',
                validate: (phone) => isValidUSPhoneNumber(phone) || 'Enter a valid phone number',
              }}
              render={({ field }) => <MaskedPhoneInput {...field} />}
            />
          }
          description={errors.phone && <FormHelp>{String(errors.phone.message)}</FormHelp>}
          error={!!errors.phone}
        />
        <FormField
          label={<Label>Email address</Label>}
          control={<Input value={email} />}
          readOnly
          description={
            <FormHelp>
              <span>
                To change the email on your account and application, go to your{' '}
                <Anchor href={getExternalUrl(EXTERNAL_URLS.PROFILE)} target="_blank" rel="noopener noreferrer">
                  account settings
                </Anchor>
                .
              </span>
            </FormHelp>
          }
        />
      </Box>
    </>
  );
}
